/**
 * Build a note list row with textContent only (no user-content innerHTML / DOMPurify).
 * Used by property notes and unit-contract notes.
 *
 * @param {{
 *   id: string|number,
 *   bodyText: string,
 *   titleText?: string,
 *   metaLines?: string[],
 *   className?: string,
 *   editBtnClass: string,
 *   deleteBtnClass: string,
 * }} opts
 */
const luxCreateNoteListItem = (opts) => {
  const noteElement = document.createElement('div')
  noteElement.className = opts.className || 'note-item'
  noteElement.dataset.noteId = String(opts.id)
  noteElement.style.marginBottom = '16px'

  const header = document.createElement('div')
  header.style.cssText =
    'display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px;'

  const metaCol = document.createElement('div')
  metaCol.style.cssText = 'display: flex; flex-direction: column; gap: 4px;'

  if (opts.titleText) {
    const title = document.createElement('div')
    title.style.fontWeight = '500'
    title.textContent = String(opts.titleText)
    metaCol.appendChild(title)
  }

  ;(opts.metaLines || []).forEach((line) => {
    if (!line) return
    const el = document.createElement('div')
    el.style.cssText = 'font-size: 12px; color: rgba(0, 0, 0, 0.45);'
    el.textContent = line
    metaCol.appendChild(el)
  })

  const actions = document.createElement('div')
  actions.style.cssText = 'display: flex; gap: 4px;'

  const editBtn = document.createElement('button')
  editBtn.type = 'button'
  editBtn.className = `ant-btn ant-btn-text ant-btn-icon-only ${opts.editBtnClass}`
  editBtn.innerHTML =
    '<span class="anticon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.05c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor"/></svg></span>'

  const deleteBtn = document.createElement('button')
  deleteBtn.type = 'button'
  deleteBtn.className = `ant-btn ant-btn-text ant-btn-icon-only ${opts.deleteBtnClass}`
  deleteBtn.innerHTML =
    '<span class="anticon" style="color: #ff4d4f;"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor"/></svg></span>'

  actions.appendChild(editBtn)
  actions.appendChild(deleteBtn)
  header.appendChild(metaCol)
  header.appendChild(actions)

  const body = document.createElement('div')
  body.className = 'lux-uc-note-body'
  body.style.cssText = 'font-size: 14px; line-height: 1.5; white-space: pre-wrap;'
  body.textContent = opts.bodyText == null ? '' : String(opts.bodyText)

  const divider = document.createElement('div')
  divider.className = 'ant-divider'
  divider.style.margin = '16px 0'

  noteElement.appendChild(header)
  noteElement.appendChild(body)
  noteElement.appendChild(divider)
  return noteElement
}
